"use client";
import { Text } from "@dxp-feed/ui/Text";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { Button } from "@dxp-feed/ui/Button";
import { Box } from "@dxp-feed/ui/Box";
import LoginModal from "../UI/Modals/LoginModal";
import SaveReminder from "../UI/Modals/saveReminderModal";
import CreateListModal from "../UI/Modals/CreateListModal";
import useCreateList from "../common/commonRecipeFunctions/useCreateList";
import { mealPlanDefautMessage, recipeModalData } from "@/utils/aemDefaultData";

const CreateNewList = ({
  addRecipeToList = false,
  selectedRecipeList,
  recipeByListId = [],
  closeFavModal,
  addedRecipetoList,
  updatedListName,
  buttonDisabled = true,
  componentName,
  closePreviousModal,
  favouriteOpen = false,
  closeAfterSearch
}: {
  addRecipeToList?: boolean;
  selectedRecipeList?: any;
  recipeByListId?: any;
  addedRecipetoList?: any;
  updatedListName?: any;
  closeFavModal?: () => void;
  buttonDisabled?: boolean;
  componentName?: string;
  closePreviousModal?: () => void;
  favouriteOpen?: boolean;
  closeAfterSearch?: () => void;
}) => {
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );

  const createListProps = useCreateList({
    closeFavModal,
    componentName,
    closePreviousModal,
    favouriteOpen,
    addRecipeToList,
    selectedRecipeList,
    addedRecipetoList,
    recipeByListId,
  });

  return (
    <>
      {/* Button to open modal */}
      <Box as="div" className="">
        {addRecipeToList ? (
          <Button
            disabled={!buttonDisabled}
            variant="primary"
            className={`gap-3 flex text-[14px] font-normal   h-10 group w-full 2xs:w-auto 
               ${buttonDisabled ? "" : "hover:text-brandBlack"} `}
            onClick={createListProps?.openModal}
            aria-label="Add Recipe"
          >
            <Text
              as="span"
              className={`RecipesList-icon icon-plus text-[14px] w-6 h-6 flex items-center 
                justify-center  group-focus:text-brandPrimary`}
            ></Text>
            <Text as="span">{aemModalData?.addRecipeTitle}</Text> 
          </Button>
        ) : (
          <Button
            variant="icon"
            size="none"
            className="gap-2 flex text-brandSecondary text-[14px] font-bold md:h-[40px] mt-1 md:mt-0 !rounded-[4px] group w-full md:w-auto justify-start"
            onClick={createListProps?.openModal}
            aria-label="Create New Recipe List"
          >
            <Text
              as="span"
              className="demo-icon icon-plus text-[14px] w-6 h-6 text-brandPrimary flex items-center justify-center"
            ></Text>
            <Text
              as="span"
              id="create_new_recipeList"
              className="relative text-brandPrimary after:absolute after:left-0 after:bottom-[4px] after:w-full after:h-[1px] after:bg-brandPrimary"
            >
              {aemModalData?.createNewRecipeListTitle}
            </Text>
          </Button>
        )}
      </Box>
      {/* Modal */}

      <CreateListModal
        {...createListProps}
        updatedListName={updatedListName}
        closeAfterSearch={closeAfterSearch}
        componentName={componentName}
        recipeByListId={recipeByListId.filter(Boolean)}
        addRecipeToList={addRecipeToList}
      />

      {/** Progress lost message */}
      <SaveReminder
        isProgressModal={createListProps?.isProgressModal}
        closeIsProgressModal={createListProps?.closeIsProgressModal}
        saveRecipesToFolder={createListProps?.saveRecipesToFolder}
        aemRecipeModelData={aemModalData}
        saveAnywayDisable={createListProps?.saveAnywayDisable}
      />
      {/** Login Modal */}
      <LoginModal
        isModalOpen={createListProps?.isLoginModalOpen}
        closeModal={createListProps?.closeLoginModal}
        label={MESSAGE?.LOGIN_MESSAGE ?? mealPlanDefautMessage[0]?.loginMessage}
      />
    </>
  );
};

export default CreateNewList;
